/** Previous factory default before full-day calendars. */
export const LEGACY_CALENDAR_TIME_WINDOW = {
  start: "08:00",
  end: "20:00",
} as const;

export const DEFAULT_CALENDAR_TIME_WINDOW = {
  start: "00:00",
  end: "24:00",
} as const;

/** Upgrade unset or legacy 8am–8pm windows to the full-day default. */
export function resolveCalendarTimeWindow(
  start?: string | null,
  end?: string | null,
): { start: string; end: string } {
  const startTrimmed = typeof start === "string" ? start.trim() : "";
  const endTrimmed = typeof end === "string" ? end.trim() : "";

  const isUnset = !startTrimmed && !endTrimmed;
  const isLegacy =
    startTrimmed === LEGACY_CALENDAR_TIME_WINDOW.start &&
    endTrimmed === LEGACY_CALENDAR_TIME_WINDOW.end;

  if (isUnset || isLegacy) {
    return { ...DEFAULT_CALENDAR_TIME_WINDOW };
  }

  return {
    start: startTrimmed || DEFAULT_CALENDAR_TIME_WINDOW.start,
    end: endTrimmed || DEFAULT_CALENDAR_TIME_WINDOW.end,
  };
}
